import axios from 'axios';

const baseURL = '/public';

export const getClientConfig = () => {
  const url = `${baseURL}/api/config/client`;
  return axios.get(url).then(res => ({ status: res?.status, data: res?.data }));
};
